import React, { useMemo } from 'react';
import { css } from '@linaria/core';
import { brand, findColorFromCSSVariable, theme } from '@terveystalo/design-system-theme';
import { Icon } from '../../atoms/Icon';
import { ScreenReaderOnly } from '../../atoms/ScreenReaderOnly';
import { Subtitle, Text } from '../../atoms/Typography';
const determineIconProps = (complete, current) => {
    let name;
    let color;
    let className;
    if (complete) {
        name = 'Check';
        // Add slight margin to the Check icon only. The Bullets have more space around them
        className = css `
      margin-right: ${theme.spacing['0_5']};
    `;
        color = brand.step.color.complete.content;
    }
    else if (current) {
        name = 'Bullet';
        color = brand.step.color.active.content;
    }
    else {
        name = 'BulletOutline';
        color = brand.step.color.upcoming.content;
    }
    return { name, color: findColorFromCSSVariable(color), className };
};
/**
 * Step component for a single progress tracker step
 */
export const Step = ({ isComplete, label, isCurrent, completeLabel }) => {
    const iconProps = useMemo(() => determineIconProps(isComplete, isCurrent), [isComplete, isCurrent]);
    const isUpcoming = !isComplete && !isCurrent;
    return (React.createElement("li", { className: css `
        display: flex;
        flex-shrink: 0;
        margin-right: ${theme.spacing[2]};
        /* Hide the completed steps in mobile so that the content fits better */
        &[data-is-complete='true'] {
          @media only screen and (max-width: ${theme.media.breakpoint.s}) {
            display: none;
          }
        }
      `, "aria-current": isCurrent ? 'step' : undefined, "data-is-complete": isComplete },
        React.createElement(Icon, { ...iconProps }),
        isUpcoming ? (React.createElement(Text, { size: "m", color: findColorFromCSSVariable(brand.step.color.upcoming.content) }, label)) : (React.createElement(Subtitle, { size: "xs" }, label)),
        React.createElement(ScreenReaderOnly, { "aria-live": "polite" }, isComplete && `${label} ${completeLabel}`)));
};


import "../../../css/molecules/ProgressTracker/Step.css";
